<template>
  <div>
    <intestinal :data="int_wor" :title="title[1]" :lst_acc="lst_acc"/>
  </div>
</template>

<script>
import Intestinal from '@/components/ascf/sharedCom/intestinal.vue'
export default {
  props: ["title", "int_wor", "lst_acc"],
  components: {
    'intestinal': Intestinal
  },
  data () {
    return {

    }
  }
}
</script>
<style scoped>

</style>